<template>
  <div v-if="blog && autoren && getLinks()">
    <v-text-field label="Titel" outlined class="mb-0 pb-0" hide-details v-model="blog.title"></v-text-field>
    <v-divider></v-divider>
    <div>
      <el-tiptap height="600" v-model="blog.content" :extensions="extensions"/>
    </div>
    <v-divider></v-divider>
    <h3>Quellen und Weblinks</h3>
    <v-list v-if="blog.links !== null && blog.links && blog.links.length != 0" class="mb-3">
        <v-list-item v-for="link in links" :key="link.link">
            <v-list-item-title>{{link.title}}</v-list-item-title>
            <v-list-item-action @click="delLink(link.link)"><v-icon color="#e74c3c">{{del}}</v-icon></v-list-item-action>
        </v-list-item>
    </v-list>
    <v-btn outlined block @click="dialog2 = true" color="#1abc9c">Weblink hinzufügen</v-btn>
    <v-divider></v-divider>
    <v-text-field label="Meta-Titel" v-model="blog.seo_title" outlined hide-details></v-text-field>
    <v-divider></v-divider>
    <v-textarea label="Meta-Beschreibung" outlined hide-details v-model="blog.meta_description"></v-textarea>
    <v-divider></v-divider>
    <v-select v-model="blog.autoren" :items="autoren.autoren" item-text="vorname" item-value="mail" chips label="Autoren" multiple item-color="#3498db"></v-select>
    <v-divider></v-divider>
    <div v-if="this.blog.einordnung">
      <h3>Einordnung</h3>
      <p>{{this.blog.einordnung.fach.title + ' → ' + this.blog.einordnung.thema.title}}</p>
    </div>
    <v-divider></v-divider>
    <p>{{blog.slug}}</p>
    <v-divider></v-divider>
    <v-switch v-model="blog.baustelle" label="Baustellen-Info"></v-switch>
    <v-divider></v-divider>
    <v-btn block outlined @click="save()" color="#2ecc71">Speichern</v-btn>
    <v-snackbar color="#2ecc71" v-model="snackbar">Gespeichert
      <v-btn dark :href="'https://lernzettel.org/' + blog.slug" target="_blank">Ansehen</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="350">
        <v-card>
          <v-card-title class="headline">Kategorie</v-card-title>
          <v-text-field class="ml-6 mr-6" v-model="title" label="Titel" single-line></v-text-field>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialog = false; addCat()">Weiter</v-btn>
            <v-btn color="red darken-1" text @click="dialog = false; title = ''">Schließen</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" max-width="350">
        <v-card>
          <v-card-title class="headline">Weblink</v-card-title>
          <v-text-field class="ml-6 mr-6" v-model="title" label="Titel" single-line></v-text-field>
          <v-text-field class="ml-6 mr-6" v-model="link" label="URL" single-line></v-text-field>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialog2 = false; addLink()">Weiter</v-btn>
            <v-btn color="red darken-1" text @click="dialog2 = false; title = ''">Schließen</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar2">Bereits belegt.
        <v-btn color="red" text @click="snackbar = false">Schließen</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
const algoliasearch = require('algoliasearch');
const client = algoliasearch('ZC0BNQ3DEW', '8f886ac8f2f380019993cfceaa3b9f51');
const index = client.initIndex('lernzettel');

import katex from 'katex';

import {
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Link,
  Image,
  CodeBlock,
  Blockquote,
  ListItem,
  BulletList,
  OrderedList,
  TodoItem,
  TodoList,
  TextAlign,
  Indent,
  LineHeight,
  HorizontalRule,
  HardBreak,
  TrailingNode,
  History,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  FormatClear,
  TextColor,
  TextHighlight,
  Preview,
  Fullscreen
} from 'element-tiptap';

import { db } from '../db'
import { fb } from '../db'
import { mdiDelete} from '@mdi/js'

class I2 extends Italic {
  pasteRules () {
    return [];
  }
}

var sl = ''

var storageRef = fb.storage().ref();

const blog = db.collection('lernzettel');
const extra = db.collection('lernzettel-extra');
const ed = db.collection('lernzettel-editor');
const sh = db.collection('shared');
import { mdiPlus} from '@mdi/js'

export default {
  watch: {
      $route: {
        immediate: true,
        handler(to, from) {
          this.$bind('blog', blog.doc(this.$route.params.lernzettel));
          this.$bind('edit', ed.doc(this.$route.params.lernzettel));
          this.$bind('kategorien', blog.doc('kategorien'));
          this.$bind('autoren', sh.doc('autoren'));
          this.$Progress.finish()
          sl = this.$route.params.lernzettel
        }
      }
  },
  methods: {
    save: function() {
      blog.doc(this.$route.params.lernzettel).set(this.blog).then(() => this.snackbar = true);
      var search = {objectID: this.blog.slug, title: this.blog.title, content: this.blog.content, seo_title: this.blog.seo_title, meta_description: this.blog.meta_description, autoren: this.blog.autoren, einordnung: this.blog.einordnung, slug: this.blog.slug}
      index.saveObject(search).then(({ objectID }) => {
          console.log(objectID + ' - ' + this.blog.slug + ' wurde indexiert.');
      });
      extra.doc('log').set({[Date.now()]: fb.auth().currentUser.email + ' hat ' + this.blog.slug + ' verändert.'}, {merge: true})
    },
    getLinks: function() {
      this.links = this.blog.links
      return true
    },
    addLink: function(){
        if(typeof this.blog.links == 'undefined' || this.blog.links == null){
          this.blog.links = []
        }
        this.blog.links.push({title: this.title, link: this.link})
        this.links = this.blog.links
        this.title = ""
        this.link = ""
    },
    delLink: function(link){
        this.blog.links = this.blog.links.filter(item => item.link !== link)
        this.links = this.blog.links
    },
    addCat: function(){
        if(this.kategorien == null){
          this.kategorien = {}
        }
        this.slug = this.toSlug(this.title)
        if(this.kategorien.kategorien == null || typeof this.kategorien.kategorien == 'undefined') {
          this.kategorien.kategorien = []
        }
        if(typeof this.kategorien.kategorien.find(x => x.slug === this.slug) == 'undefined') {
          this.kategorien.kategorien.push({title: this.title, slug: this.slug})
          blog.doc('kategorien').set({ kategorien: this.kategorien.kategorien });
        } else {
          this.title = '';
          this.slug = '';
          this.snackbar2 = true;
        }
    },
    toSlug: function(str){
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
        // remove accents, swap ñ for n, etc
        var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
        var to   = "aaaaaeeeeeiiiiooooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes
        return str;
      }
  },
  mounted: function(){
    if(this.$route.params.lernzettel !== ''){
      this.$bind('blog', blog.doc(this.$route.params.lernzettel));
      this.$bind('edit', ed.doc(this.$route.params.lernzettel));
      this.$bind('kategorien', blog.doc('kategorien'));
      this.$bind('autoren', sh.doc('autoren'));
      this.$Progress.finish()
      sl = this.$route.params.lernzettel
    }
  },
  data: () => ({
    renderedc: '',
    del: mdiDelete,
    links: [],
    snackbar: false,
    autoren: {},
    snackbar2: false,
    dialog2: false,
    kategorien: [],
    title: '',
    link: '',
    slug: '',
    dialog: false,
    plus: mdiPlus,
    blog: {},
    edit: {},
    extensions: [
      new Doc(),
      new Text(),
      new Paragraph(),
      new Heading({ level: 5 }),
      new Bold({ bubble: true }), // render command-button in bubble menu.
      new Underline(),
      new I2(),
      new Strike(),
      new ListItem(),
      new BulletList(),
      new OrderedList(),
      new Link(),
      new Image({
        bubble: true,
        uploadRequest(file) {
          return new Promise((resolve) => {
            var ref = storageRef.child(sl + '/' + file.name);
            ref.put(file).then(() => {
              ref.getDownloadURL().then((url) => {
                resolve(url);
              })
            })
          })
        }
      }),
      new CodeBlock(),
      new Blockquote(),
      new ListItem(),
      new BulletList(),
      new OrderedList(),
      new TodoItem(),
      new TodoList(),
      new TextAlign(),
      new Indent(),
      new LineHeight(),
      new HorizontalRule(),
      new HardBreak(),
      new TrailingNode(),
      new History(),
      new Table(),
      new TableHeader(),
      new TableCell(),
      new TableRow(),
      new FormatClear(),
      new TextColor(),
      new TextHighlight(),
      new Preview(),
      new Fullscreen()
    ]
  })
}
</script>